import React from 'react'
import { GraphMenuItemDiv } from './styled-elements'

const GraphMenuItem = ({text, clickHandler}) => {

  const ret = <GraphMenuItemDiv onClick={clickHandler}>
    {text}
  </GraphMenuItemDiv>

  return ret

}

export default GraphMenuItem



// WEBPACK FOOTER //
// ./src/components/dataViews/controls/GraphMenuItem.js